module.exports = __webpack_public_path__ + "media/03.83e84e04.wav";